import { gql } from '@apollo/client';

export const deleteStationLog = gql`
  mutation deleteStationLog($id: String) {
    deleteStationLog(id: $id)
  }
`;
